// actions/attendanceActions.js
import createApi from "../utils/apiClient";
const api = createApi();

export const markStudentAttendance = (payload) => async (dispatch) => {
  try {
    dispatch({ type: "MARK_ATTENDANCE_REQUEST" });
    await api.post("/attendance/student/mark", payload);
    dispatch({ type: "MARK_ATTENDANCE_SUCCESS" });
  } catch (err) {
    dispatch({
      type: "MARK_ATTENDANCE_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const markStaffAttendance = (payload) => async (dispatch) => {
  try {
    dispatch({ type: "MARK_ATTENDANCE_REQUEST" });
    await api.post("/attendance/staff/mark", payload);
    dispatch({ type: "MARK_ATTENDANCE_SUCCESS" });
  } catch (err) {
    dispatch({
      type: "MARK_ATTENDANCE_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const getStudentAttendance = (params) => async (dispatch) => {
  try {
    dispatch({ type: "GET_ATTENDANCE_REQUEST" });
    const { data } = await api.get("/attendance/student", { params });
    dispatch({ type: "GET_ATTENDANCE_SUCCESS", payload: data.attendance });
  } catch (err) {
    dispatch({
      type: "GET_ATTENDANCE_FAIL",
      payload: err.response?.data?.message,
    });
  }
};

export const getAttendanceSummary = (params) => async (dispatch) => {
  try {
    dispatch({ type: "GET_ATTENDANCE_REQUEST" });
    const { data } = await api.get("/attendance/summary", { params });
    dispatch({ type: "GET_ATTENDANCE_SUMMARY_SUCCESS", payload: data.summary });
  } catch (err) {
    dispatch({
      type: "GET_ATTENDANCE_FAIL",
      payload: err.response?.data?.message,
    });
  }
};
